import { createSvgIcon, SvgIconProps } from "@material-ui/core";

const ExchangeRateIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2zM4 16c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12S4 22.627 4 16zm15.707-3.707a1 1 0 00-1.414-1.414L17 12.172V8a1 1 0 10-2 0v4.172l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3zm-7.414 7.414a1 1 0 001.414 1.414L15 19.828V24a1 1 0 102 0v-4.172l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3z"
    fill="currentColor"
  />,
  "ExchangeRate",
);

export default function ExchangeRate(props: SvgIconProps) {
  return <ExchangeRateIcon {...props} viewBox="0 0 32 32" />;
}
